import styled from 'styled-components'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { NavLink } from 'react-router-dom'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import SearchInputUser from "../usuariosAdmin/searchInputUser.jsx"

const Container=styled.div`
	display:flex;
	align-items:center;
	justify-content:space-between;
	width:96%
 `;


 export default function NavigationReventas(){
 	const [value, setValue] = useState(0);
 	const estadoReventas=useSelector(state=>state.reventa.reventasEstado);




 	const handleChange=(e,newValue)=>{ setValue(newValue) };
 
 	return(
 		<Container>
 			
 			<Box >
	     		<Tabs value={value} disabled={true} onChange={handleChange}  style={{ textDecoration: "none" }} textColor="primary" indicatorColor="primary" allowScrollButtonsMobile scrollButtons variant="scrollable" >
        			<Tab disabled={estadoReventas!==0?true:false}  label="reventas" to="reventasPublicadas" component={NavLink} />
        			<Tab disabled={estadoReventas!==0?true:false}  label="juegos" to="juegosCliente" component={NavLink} />
        		</Tabs>
      		</Box>
      		<div>
      			<SearchInputUser/>
      		</div>
 			
 		</Container>
 		)
 }